import { HEAT_GRADIENT } from '../HeatMapLayer';

const formatValue = (value, mode) => {
  if (mode === 'heat_dollars') {
    if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`;
    return `$${Math.round(value)}`;
  }
  if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return String(Math.round(value));
};

export function HeatMapLegend({ stats, mode }) {
  if (!stats || stats.max === 0) return null;

  const label = mode === 'heat_dollars' ? 'Donation Amount' : 'Donation Count';

  // Build gradient CSS from the HEAT_GRADIENT stops
  const stops = Object.entries(HEAT_GRADIENT)
    .sort(([a], [b]) => Number(a) - Number(b))
    .map(([pct, color]) => `${color} ${Math.round(Number(pct) * 100)}%`)
    .join(', ');

  // Generate intermediate tick values (sqrt-scaled to match the normalization)
  const ticks = [0, 0.25, 0.5, 0.75, 1.0];
  const tickValues = ticks.map(t => {
    // Reverse the sqrt normalization: display value = t^2 * max
    const rawFrac = t * t;
    return stats.min + rawFrac * (stats.max - stats.min);
  });

  return (
    <div
      className="absolute top-3 right-3 z-[1000] bg-card/95 backdrop-blur-sm border rounded-lg shadow-lg px-3 py-2.5 text-xs"
      data-testid="heatmap-legend"
    >
      <div className="font-medium text-foreground mb-1.5">{label}</div>
      <div
        className="h-3 w-48 rounded-sm border"
        style={{ background: `linear-gradient(to right, ${stops})` }}
      />
      <div className="flex justify-between mt-1 text-[10px] text-muted-foreground w-48">
        {ticks.map((t, i) => (
          <span key={i} className={i === ticks.length - 1 ? 'text-right' : i === 0 ? 'text-left' : 'text-center'}>
            {formatValue(tickValues[i], mode)}
          </span>
        ))}
      </div>
      <div className="mt-1.5 pt-1.5 border-t text-[10px] text-muted-foreground">
        <span className="font-medium text-foreground">Max:</span> {formatValue(stats.max, mode)}
        <span className="mx-1.5">&middot;</span>
        <span className="font-medium text-foreground">Min:</span> {formatValue(stats.min, mode)}
      </div>
    </div>
  );
}
